const errorMap = {
  user_exists: "Пользователь с таким логином уже существует"
};
export function mapErrorCode(code) {
  return errorMap[code] || code;
}

export function errorMessage(error) {
  return (
    mapErrorCode(error.error || error.code || error.message) ||
    "Не удалось выполнить запрос"
  );
}

export function createApiError(status, body, code) {
  const error = new Error(
    (body && typeof body.error === "string" && body.error) ||
      `Ошибка запроса (${status})`
  );
  error.status = status;
  error.code = code || (body && body.error);
  error.error = body && body.error;
  error.data = (body && body.data) || {};
  return error;
}

export function decodeFileError(error) {
  if (!error.response) return error;
  const { status, data, headers } = error.response;
  let body = null;
  try {
    body = JSON.parse(new TextDecoder().decode(data));
  } catch {
    // Binary download failures can contain non-JSON proxy responses.
  }
  return createApiError(status, body, headers && headers["x-error-code"]);
}

export function validateDescription(description) {
  return Array.from(description || "").length <= 255
    ? []
    : ["Максимальная длина поля 255 символов"];
}
